import { render, staticRenderFns } from "./inviteRegSuccess.vue?vue&type=template&id=69ca63e1&"
import script from "./inviteRegSuccess.vue?vue&type=script&lang=js&"
export * from "./inviteRegSuccess.vue?vue&type=script&lang=js&"
import style0 from "./inviteRegSuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports